/**
 * ==========================================
 * OB Store - Libro de Reclamaciones
 * ==========================================
 */

class OBClaims {

  constructor() {

    this.form = document.getElementById('obClaimsForm');

    if (!this.form) return;

    this.submitButton = this.form.querySelector('[type="submit"]');

    this.apiUrl = 'https://script.google.com/macros/s/AKfycbyUsSaXvDlchCaDLJTbz2jQGOG5W4NGpxIzQfLeZuemz3Ajr4yw1uvHB31juNaO4WmH/exec';

    this.apiKey = 'OBSTORE-2026-7F4A91B8';

    this.bindEvents();

this.initializeForm();

this.initEvidenceUpload();

    const newClaimButton = document.getElementById('obNewClaim');

if (newClaimButton) {

    newClaimButton.addEventListener(

        'click',

        () => this.resetForm()

    );

}

  }

  initEvidenceUpload() {

    this.fileInput = document.getElementById('ob-evidence-input');

    this.fileList = document.getElementById('ob-upload-list');

    if (!this.fileInput || !this.fileList) {

        return;

    }

    this.selectedFile = null;

    this.fileInput.addEventListener('change', () => {

        this.fileList.innerHTML = '';

        if (!this.fileInput.files.length) {

            this.selectedFile = null;

            return;

        }

        const file = this.fileInput.files[0];

        const maxSize = 10 * 1024 * 1024;

        const allowed = [

            'image/jpeg',

            'image/png',

            'image/webp',

            'application/pdf'

        ];

        if (!allowed.includes(file.type)) {

            alert('Solo se permiten archivos JPG, PNG, WEBP o PDF.');

            this.fileInput.value = '';

            return;

        }

        if (file.size > maxSize) {

            alert('El archivo supera el tamaño máximo de 10 MB.');

            this.fileInput.value = '';

            return;

        }

        this.selectedFile = file;

        const item = document.createElement('div');

item.className = 'ob-upload__item';

item.innerHTML = `
    <div class="ob-upload__content">
        <div>
            <strong>📎 ${file.name}</strong><br>
            <small>${(file.size / 1024 / 1024).toFixed(2)} MB</small>
        </div>

        <button
            type="button"
            class="ob-upload__remove"
            aria-label="Eliminar archivo"
            title="Eliminar archivo">
            ✕
        </button>
    </div>
`;

item
    .querySelector('.ob-upload__remove')
    .addEventListener('click', () => {

        this.selectedFile = null;

        this.fileInput.value = '';

        this.fileList.innerHTML = '';

    });

this.fileList.appendChild(item);

    });

}

/**
 * ==================================================
 * Convierte un archivo a Base64
 * ==================================================
 */

fileToBase64(file) {

    return new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.onload = () => {

            const base64 = reader.result.split(",")[1];

            resolve(base64);

        };

        reader.onerror = reject;

        reader.readAsDataURL(file);

    });

}

 bindEvents() {

    this.form.addEventListener(
        'submit',
        this.handleSubmit.bind(this)
    );

    this.form.addEventListener(
        'input',
        this.handleLiveValidation.bind(this)
    );

    this.form.addEventListener(
        'change',
        this.handleDocumentTypeChange.bind(this)
    );

    this.form.addEventListener(
        'blur',
        this.handleBlurValidation.bind(this),
        true
    );

}

/**
 * ==================================================
 * Inicializa el formulario
 * ==================================================
 */

initializeForm() {

    const documentType = this.getField('ob_document_type');

    if (!documentType) {
        return;
    }

    this.handleDocumentTypeChange({
        target: documentType
    });

}

/**
 * ==================================================
 * Validación en tiempo real
 * ==================================================
 */

handleLiveValidation(event) {

    const field = event.target;

    if (!field.name) {
        return;
    }

    this.clearFieldState(field.name);

    switch (field.name) {

        case 'ob_email':

            if (field.value.trim() === '') {
                return;
            }

            if (this.isValidEmail(field.value.trim())) {

                this.showValid('ob_email');

            } else {

                this.showError(
                    'ob_email',
                    'Ingresa un correo electrónico válido.'
                );

            }

            break;

            case 'ob_document_type':

            this.handleDocumentTypeChange({
            target: field
            });

           break;
        
        case 'ob_document_number': {

        const type = this.getField('ob_document_type').value;

        const rules = this.getDocumentRules(type);

        if (!rules) {
        return;
        }

        if (rules.numeric) {

        const cleanValue = field.value.replace(/\D/g, '');

        if (cleanValue !== field.value) {
            field.value = cleanValue;
        }

        }

        // Mientras escribe NO mostramos errores
        if (field.value.length < rules.maxLength) {
        return;
        }

        this.validateDocument(false);

        break;

        }

        case 'ob_phone': {

    const rules = this.getPhoneRules();

    const phone = this.normalizePhone(field.value);

    if (phone !== field.value) {
        field.value = phone;
    }

    if (phone.length < rules.length) {
        return;
    }

    this.validatePhone(false);

    break;

    }

    }

}

/**
 * ==================================================
 * Validación al abandonar un campo
 * ==================================================
 */

handleBlurValidation(event) {

    const field = event.target;

    if (!field.name) {
        return;
    }

    switch (field.name) {

        case 'ob_document_number':

            this.validateDocument();

            break;

        case 'ob_email':

            this.validateEmail(
                this.collectData()
            );

            break;
        
        case 'ob_phone':

            this.validatePhone();

            break;

    }

}

/**
 * ==================================================
 * Cambio de tipo de documento
 * ==================================================
 */

handleDocumentTypeChange(event) {

    if (event.target.name !== 'ob_document_type') {
        return;
    }

    const documentField = this.getField('ob_document_number');

    if (!documentField) {
        return;
    }

    const type = event.target.value;

    const rules = this.getDocumentRules(type);

if (!rules) {
    return;
}

documentField.value = '';

this.clearFieldState('ob_document_number');

documentField.placeholder = rules.placeholder;
documentField.maxLength = rules.maxLength;
documentField.inputMode = rules.numeric ? 'numeric' : 'text';

}

/**
 * ==================================================
 * Reglas de documentos
 * ==================================================
 */

getDocumentRules(type) {

    const rules = {

        'DNI': {
            maxLength: 8,
            numeric: true,
            placeholder: 'Ingrese 8 dígitos',
            invalidMessage: 'El DNI debe tener 8 dígitos.'
        },

        'RUC': {
            maxLength: 11,
            numeric: true,
            placeholder: 'Ingrese 11 dígitos',
            invalidMessage: 'El RUC debe tener 11 dígitos.'
        },

        'Carnet de Extranjería': {
            maxLength: 9,
            numeric: true,
            placeholder: 'Ingrese 9 dígitos',
            invalidMessage: 'El Carnet de Extranjería debe tener 9 dígitos.'
        },

        'Pasaporte': {
            maxLength: 20,
            numeric: false,
            placeholder: 'Ingrese su pasaporte',
            invalidMessage: 'Ingresa un número de pasaporte válido.'
        }

    };

    return rules[type] || null;

}

/**
 * ==================================================
 * Reglas del teléfono
 * ==================================================
 */

getPhoneRules() {

    return {

        length: 9,

        startsWith: '9',

        countryCode: '51',

        placeholder: '987654321'

    };

}

/**
 * ==================================================
 * Normaliza el teléfono
 * ==================================================
 */

normalizePhone(value) {

    if (!value) {
        return '';
    }

    let phone = value.replace(/\D/g, '');

    const rules = this.getPhoneRules();

    if (phone.startsWith(rules.countryCode) && phone.length === 11) {
    phone = phone.substring(2);
}

phone = phone.substring(0, rules.length);

return phone;

}

/**
 * ==================================================
 * Valida el teléfono
 * ==================================================
 */

validatePhone(showError = true) {

    const field = this.getField('ob_phone');

    if (!field) {
        return false;
    }

    const rules = this.getPhoneRules();

    const phone = this.normalizePhone(field.value);

    if (phone === '') {

        if (showError) {

            this.showError(
                'ob_phone',
                'Ingrese el teléfono.'
            );

        }

        return false;

    }

    if (phone.length !== rules.length) {

        if (showError) {

            this.showError(
                'ob_phone',
                `El teléfono debe tener ${rules.length} dígitos.`
            );

        }

        return false;

    }

    if (!phone.startsWith(rules.startsWith)) {

        if (showError) {

            this.showError(
                'ob_phone',
                `El teléfono debe comenzar con ${rules.startsWith}.`
            );

        }

        return false;

    }

    field.value = phone;

    this.showValid('ob_phone');

    return true;

}

/**
 * ==================================================
 * Valida el documento de identidad
 * ==================================================
 */

validateDocument(showError = true) {

    const typeField = this.getField('ob_document_type');
    const numberField = this.getField('ob_document_number');

    if (!typeField || !numberField) {
        return false;
    }

    const type = typeField.value;
    const value = numberField.value.trim();

    const rules = this.getDocumentRules(type);

    if (!rules) {
        return false;
    }

    if (value === '') {

        if (showError) {

            this.showError(
                'ob_document_number',
                'Ingresa el número de documento.'
            );

        }

        return false;

    }

    if (rules.numeric && !/^\d+$/.test(value)) {

        if (showError) {

            this.showError(
                'ob_document_number',
                'Solo se permiten números.'
            );

        }

        return false;

    }

    if (value.length !== rules.maxLength) {

        if (showError) {

           this.showError(
    'ob_document_number',
    rules.invalidMessage
);

        }

        return false;

    }

    this.showValid('ob_document_number');

    return true;

}

/**
 * ==================================================
 * Limpia el estado visual de un campo
 * ==================================================
 */

clearFieldState(name) {

    const field = this.getField(name);

    if (!field) return;

    field.classList.remove('ob-error');
    field.classList.remove('ob-valid');

    const wrapper = field.closest('.ob-form-field');

    if (!wrapper) return;

    const error = wrapper.querySelector('.ob-field-error');

    if (error) {
        error.remove();
    }

}

  collectData() {

  const data = {};

  const fields = this.form.querySelectorAll(
    'input[name], select[name], textarea[name]'
  );

  fields.forEach(field => {

    if (field.type === 'checkbox') {

      data[field.name] = field.checked;

      return;

    }

    if (field.type === 'radio') {

      if (field.checked) {

        data[field.name] = field.value;

      }

      return;

    }

    data[field.name] = field.value.trim();

  });

  data.apiKey = this.apiKey;

  return data;

}

/**
 * ==================================================
 * Obtiene un campo del formulario
 * ==================================================
 */

getField(name){

    return this.form.querySelector(`[name="${name}"]`);

}


/**
 * ==================================================
 * Muestra un error en un campo
 * ==================================================
 */

showError(name, message){

    const field = this.getField(name);

    if(!field) return;

    const wrapper = field.closest('.ob-form-field');

    if(!wrapper) return;

    field.classList.remove('ob-valid');

    field.classList.add('ob-error');

    let error = wrapper.querySelector('.ob-field-error');

    if(!error){

        error = document.createElement('div');

        error.className = 'ob-field-error';

        wrapper.appendChild(error);

    }

    error.textContent = message;

}


/**
 * ==================================================
 * Limpia todos los errores
 * ==================================================
 */

clearErrors(){

    this.form
        .querySelectorAll('.ob-error')
        .forEach(field=>field.classList.remove('ob-error'));

    this.form
        .querySelectorAll('.ob-valid')
        .forEach(field=>field.classList.remove('ob-valid'));

    this.form
        .querySelectorAll('.ob-field-error')
        .forEach(error=>error.remove());

}


/**
 * ==================================================
 * Marca un campo como válido
 * ==================================================
 */

showValid(name){

    const field = this.getField(name);

    if(!field) return;

    const wrapper = field.closest('.ob-form-field');

    if(!wrapper) return;

    field.classList.remove('ob-error');

    field.classList.add('ob-valid');

    const error = wrapper.querySelector('.ob-field-error');

    if(error){

        error.remove();

    }

}


/**
 * ==================================================
 * Valida un correo electrónico
 * ==================================================
 */

isValidEmail(email){

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

}

validateEmail(data) {

    const field = this.getField('ob_email');

    if (!field) {
        return false;
    }

   if (data.ob_email === '') {
    return true;
}

if (this.isValidEmail(data.ob_email)) {

    this.showValid('ob_email');
    return true;

}

this.showError('ob_email', 'Ingresa un correo electrónico válido.');

return false;
}

validate(data) {

    this.clearErrors();

const required = {

    ob_document_type: "Seleccione el tipo de documento.",

    ob_document_number: "Ingrese el número de documento.",

    ob_first_name: "Ingrese los nombres.",

    ob_last_name: "Ingrese el apellido paterno.",

    ob_second_last_name: "Ingrese el apellido materno.",

    ob_email: "Ingrese el correo electrónico.",

    ob_phone: "Ingrese el teléfono.",

    ob_purchase_channel: "Seleccione el canal de compra.",

    ob_product_type: "Seleccione Producto o Servicio.",

    ob_claim_type: "Seleccione Queja o Reclamo.",

    ob_claim_detail: "Ingrese el detalle del reclamo.",

    ob_consumer_request: "Ingrese su pedido.",

    ob_accept: "Debe aceptar la declaración."

};

let isValid = true;

for (const field in required) {

    const value = data[field];
    const input = this.getField(field);

    const isEmpty =
        value === undefined ||
        value === null ||
        value === '' ||
        value === false;

    if (isEmpty) {

        isValid = false;

        this.showError(
            field,
            required[field]
        );

        continue;

    }

    if (
        field !== 'ob_email' &&
        field !== 'ob_document_number' &&
        field !== 'ob_phone'
    ) {

        this.showValid(field);

    }

}

if (!this.validateDocument()) {
    isValid = false;
}

if (!this.validateEmail(data)) {
    isValid = false;
}

if (!this.validatePhone()) {
    isValid = false;
}

if (!isValid) {

    const firstError = this.form.querySelector('.ob-error');

    if (firstError) {

        firstError.focus({
            preventScroll: true
        });

        firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

    }

}

return isValid;

}

async submit(data) {

    // Registrar el reclamo
    const response = await fetch(this.apiUrl, {

        method: 'POST',

        body: JSON.stringify(data)

    });

    const result = await response.json();

    // Si hubo error o no hay archivo, terminar aquí
    if (!result.success || !this.selectedFile) {

        return result;

    }

    // Convertir archivo a Base64
    const fileData = await this.fileToBase64(this.selectedFile);

    // Subir evidencia
    const uploadResponse = await fetch(this.apiUrl, {

        method: 'POST',

        body: JSON.stringify({

            action: "uploadEvidence",

            claimNumber: result.claimNumber,

            fileName: this.selectedFile.name,

            mimeType: this.selectedFile.type,

            fileData: fileData

        })

    });

    const uploadResult = await uploadResponse.json();

if (!uploadResult.success) {

    result.evidenceWarning =
        uploadResult.message ||
        "La evidencia no pudo guardarse.";

}

return result;

}

async handleSubmit(event) {

    event.preventDefault();

    const data = this.collectData();

    if (!this.validate(data)) {

        return;

    }

    this.showLoading();

    try {

        const result = await this.submit(data);

        console.log(result);

        this.hideLoading();

        if (result.success) {

            this.showSuccess(result);

            return;

        }

        alert(
            result.message ||
            'Ocurrió un error al registrar el reclamo.'
        );

    }

    catch (error) {

        this.hideLoading();

        console.error(error);

        alert('No fue posible conectar con el servidor.');

    }

}

showSuccess(result) {

    const form = document.getElementById('obClaimsForm');

    const success = document.getElementById('obClaimsSuccess');

    const claimNumber = document.getElementById('obClaimNumber');

    if (claimNumber) {

        claimNumber.textContent = result.claimNumber;

    }

    if (form) {

      form.reset();

        form.style.display = 'none';

    }

    if (success) {

        success.hidden = false;

        success.scrollIntoView({

            behavior: 'smooth',

            block: 'start'

        });

        const downloadButton = document.getElementById('obDownloadPdf');

if (downloadButton && result.pdfUrl) {

    downloadButton.onclick = () => {

        window.open(result.pdfUrl, '_blank');

    };

}

    }

}

resetForm() {

    const form = document.getElementById('obClaimsForm');

    const success = document.getElementById('obClaimsSuccess');

    if (success) {

        success.hidden = true;

    }

    if (form) {

        form.reset();

        this.clearErrors();

        form.style.display = '';

    }

    window.scrollTo({

        top: 0,

        behavior: 'smooth'

    });

}

/**
 * ==================================================
 * Loading
 * ==================================================
 */

showLoading() {

    const loading = document.getElementById(
        'ob-claims-loading'
    );

    if (!loading) {
        return;
    }

    loading.classList.add('is-active');

}

hideLoading() {

    const loading = document.getElementById(
        'ob-claims-loading'
    );

    if (!loading) {
        return;
    }

    loading.classList.remove('is-active');

}

}

document.addEventListener('DOMContentLoaded', () => {

  new OBClaims();

});